import React, { useState, useEffect } from 'react';
import './css/LoginPage.css';

const LoginPage = () => {
  const [formData, setFormData] = useState({ usercode: '', password: '', rememberMe: false });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  useEffect(() => {
    const checkRememberToken = async () => {
      const rememberToken = localStorage.getItem('rememberToken');
      if (!rememberToken) return;
      setLoading(true);
      try {
        const response = await fetch('/api/login/remember-login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ rememberToken })
        });
        const data = await response.json();
        if (data.success) {
          localStorage.setItem('user', JSON.stringify(data.user));
          window.location.href = '/ChatboxPage';
        } else {
          localStorage.removeItem('rememberToken');
        }
      } catch (err) {
        console.error('Auto-login error:', err);
        localStorage.removeItem('rememberToken');
      } finally {
        setLoading(false);
      }
    };
    checkRememberToken();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/login/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('user', JSON.stringify(data.user));
        if (data.rememberToken) {
          localStorage.setItem('rememberToken', data.rememberToken);
        } else {
          localStorage.removeItem('rememberToken');
        }
        window.location.href = '/ChatboxPage';
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Connection error. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-header-badge">Ikigai ForHim · Appointment System (Chinese Version)</div>
          <h2>欢迎回来</h2>
          <p>Sign in to your account to continue</p>
        </div>
        <div className="login-divider" />
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label htmlFor="usercode">User Code</label>
            <input type="text" id="usercode" name="usercode" value={formData.usercode}
              onChange={handleChange} required autoComplete="off" placeholder="Enter your user code" />
          </div>
			<div className="form-group">
			  <label htmlFor="password">Password</label>
			  <div style={{ position: 'relative' }}>
				<input
				  type={showPassword ? 'text' : 'password'}
				  id="password"
				  name="password"
				  value={formData.password}
				  onChange={handleChange}
				  required
				  placeholder="Enter your password"
				  style={{ paddingRight: '40px', width: '100%', boxSizing: 'border-box' }}
				/>
				<span
				  onClick={() => setShowPassword(!showPassword)}
				  style={{
					position: 'absolute', right: '10px', top: '50%',
					transform: 'translateY(-50%)', cursor: 'pointer',
					userSelect: 'none', color: '#888', display: 'flex', alignItems: 'center'
				  }}
				>
				  {showPassword ? (
					// Eye-off (hide)
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
					  fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
					  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
					  <line x1="1" y1="1" x2="23" y2="23"/>
					</svg>
				  ) : (
					// Eye (show)
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
					  fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
					  <circle cx="12" cy="12" r="3"/>
					</svg>
				  )}
				</span>
			  </div>
			</div>
          <div className="checkbox-group">
            <label className="checkbox-label" htmlFor="rememberMe">
              <input type="checkbox" id="rememberMe" name="rememberMe"
                checked={formData.rememberMe} onChange={handleChange} className="checkbox-input" />
              <span className="checkbox-text">Remember Me</span>
            </label>
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
        <div className="login-footer">© {new Date().getFullYear()} Ikigai Center. All rights reserved.</div>
      </div>
    </div>
  );
};

export default LoginPage;